import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as personalDataAction from "./personalDataAction";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import MessageBox from "../common/MessageBox";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { TextInput } from "../common/form";
import validationUtils from "../../utils/ValidationUtils";
import { personalDataValidationRules } from "./personalDataValidationRules";
import { Button } from "react-bootstrap";
import PersonalDataFormVerification from "./PersonalDataFormVerification";
import { AUTHENTICATE_MEMBER, UPDATE_MEMBER } from "./personalDataModels";
import { toast } from "react-toastify";
import { BSModal } from "../common";
import PersonalDataMemberForm from "./PersonalDataMemberForm";
import { toCamelCase } from "../common/form/DBEnumStringHelper";
import { isSimpleFetchToast } from "../common/RouteValidators/ClientValidationHelper";
class PersonalDataForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.closeVerificationCodeModal = this.closeVerificationCodeModal.bind(this);
        this.handleSubmitForVerificationCode = this.handleSubmitForVerificationCode.bind(this);
        this.handleMemberFormSubmit = this.handleMemberFormSubmit.bind(this);

        this.state = {
            showVerificationModal: false,
            formAndMemberData: null,
            showFormStartPopup: false,
            readOnly: false,
            showFormEndModal: false,
            submitComplete: false,
            blockSubmit: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { certificateAndEmailValidated } = this.props;
        if (prevProps.certificateAndEmailValidated !== certificateAndEmailValidated) {
            this.setState({
                showVerificationModal: certificateAndEmailValidated,
            });
        }

        if (prevState.formAndMemberData === null && this.state.formAndMemberData) {
            this.setState({ showFormStartPopup: true });
        }
    }

    validateFieldsForSubmission() {
        const { memberIdentifier, existingEmail, confirmExistingEmail, blockSubmit } = this.props;
        const areFieldsEmpty = !existingEmail || !confirmExistingEmail || !memberIdentifier || blockSubmit;

        return areFieldsEmpty;
    }

    closeVerificationCodeModal() {
        const { setBlockSubmit, resetEmailValidation } = this.props;
        setBlockSubmit(false);
        this.setState({ showVerificationModal: false });
        resetEmailValidation();
    }

    renderInfoModal() {
        const { formAndMemberData } = this.state;
        const { languageCode } = this.props;

        let clientInfoTitle = "";
        let clientInfoMessage = "";

        if (formAndMemberData) {
            const hasPersonalDataPopupMessage = formAndMemberData["client"]["hasPersonalDataPopupMessage"];
            if (hasPersonalDataPopupMessage) {
                const memberPersonalDataLocalizations = formAndMemberData["memberPersonalDataLocalizations"];
                if (memberPersonalDataLocalizations) {
                    const clientInfoLocale = memberPersonalDataLocalizations.find(
                        (elem) => elem["languageCode"] == languageCode
                    );

                    if (clientInfoLocale) {
                        clientInfoTitle = clientInfoLocale["infoTitle"];
                        clientInfoMessage = clientInfoLocale["infoMessage"];
                        if (clientInfoTitle && clientInfoMessage) {
                            return (
                                <BSModal
                                    backdrop={false}
                                    show={this.state.showFormStartPopup}
                                    closeButtonKey="common.cancel"
                                    onClose={() => this.setState({ showFormStartPopup: false })}
                                    title={<span>{clientInfoTitle}</span>}
                                >
                                    <span className="pre-wrap">{clientInfoMessage}</span>
                                </BSModal>
                            );
                        }
                    }
                }
            }

            return <i className="hidden" />;
        }
    }

    handleSubmitForVerificationCode(checkCode) {
        const { personalDataActions, memberIdentifier, existingEmail, clientDesignator } = this.props;
        const values = { ...checkCode, memberIdentifier, existingEmail };

        const model = AUTHENTICATE_MEMBER(clientDesignator);

        personalDataActions.get(model, values).then((res) => {
            const simpleFetchToast = isSimpleFetchToast(res);

            if (!res.payload.error) {
                /**
                 * If we don't get an error response, we know that the user received the verification code email.
                 */
                const apiData = res.payload.data;
                this.setState({
                    formAndMemberData: apiData,
                    showVerificationModal: false,
                    readOnly: true,
                });
            } else if(!simpleFetchToast) {
                toast(<FormattedMessage id="personalData.form.infoError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            }
        });
    }

    renderFormEndModal() {
        return (
            <BSModal
                backdrop={false}
                show={this.state.showFormEndModal}
                closeButtonKey="common.cancel"
                onClose={() => this.setState({ showFormEndModal: false })}
                title={
                    <span>
                        <FormattedMessage id="personalData.form.formEndTitle" />
                    </span>
                }
            >
                <span>
                    <FormattedMessage id="personalData.form.formEndMessage" />
                </span>
            </BSModal>
        );
    }

    handleMemberFormSubmit(formValues) {
        const { memberIdentifier, existingEmail, clientDesignator, checkCode } = this.props;
        const formLanguageCode = this.props.languageCode;
        const values = {
            ...formValues,
            memberIdentifier,
            existingEmail,
            checkCode,
            formLanguageCode,
        };
        const { personalDataActions } = this.props;

        delete values["gRecaptchaResponse"];
        const model = UPDATE_MEMBER(clientDesignator);
        personalDataActions.patch(model, values).then((res) => {
            const simpleFetchToast = isSimpleFetchToast(res);

            if (!res.payload.error) {
                this.setState({ showFormEndModal: true, submitComplete: true });
            } else if(!simpleFetchToast) {
                toast(<FormattedMessage id="personalData.form.infoError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            }
        });
    }

    render() {
        const { configMessage, fieldsToShow, blockSubmit, checkCodeValidity } = this.props;
        const { readOnly, formAndMemberData, submitComplete } = this.state;

        return (
            <div>
                <h3 id="form-title">
                    <FormattedMessage id="personalData.form.title" />
                </h3>
                <hr />
                <p>
                    <FormattedMessage id="personalData.form.readInfoWarn" />
                </p>
                <h4>
                    <FormattedMessage id="personalData.form.conditions" />
                </h4>
                <p>
                    <FormattedHTMLMessage id="personalData.form.definedConditions" />
                </p>
                <h4>
                    <FormattedMessage id="personalData.form.procedure" />
                </h4>
                <p>
                    <FormattedHTMLMessage id="personalData.form.definedProcedure" />
                </p>
                <h3 className="personal-data-h3">
                    <FormattedMessage id="personalData.form.formToFillTitle" />
                </h3>

                {configMessage && (
                    <MessageBox className="alert-info bg-transparent">
                        <span className="pre-wrap">{configMessage}</span>
                    </MessageBox>
                )}

                <form disabled={blockSubmit} onSubmit={this.props.handleSubmit}>
                    <div className="personal-data-auth-section">
                        <p>
                            <FormattedMessage id="personalData.form.infoAboutSubmission" />
                        </p>
                        <Field
                            id="memberIdentifier"
                            name="memberIdentifier"
                            component={TextInput}
                            disabled={readOnly}
                            label={<FormattedMessage id="personalData.form.memberIdentifier" />}
                        />
                        <Field
                            id="existingEmail"
                            name="existingEmail"
                            component={TextInput}
                            disabled={readOnly}
                            label={<FormattedMessage id="personalData.form.email" />}
                        />
                        <Field
                            id="confirmExistingEmail"
                            name="confirmExistingEmail"
                            component={TextInput}
                            disabled={readOnly}
                            label={<FormattedMessage id="personalData.form.confirmEmail" />}
                        />
                        {!readOnly && (
                            <Button
                                type="submit"
                                disabled={this.validateFieldsForSubmission()}
                                className="submit-btn btn btn-lg btn-primary"
                            >
                                <FormattedMessage id="personalData.form.submitBtn" />
                            </Button>
                        )}
                    </div>
                </form>
                {formAndMemberData && (
                    <PersonalDataMemberForm
                        ref="form"
                        fieldsToShow={fieldsToShow}
                        onSubmit={this.handleMemberFormSubmit}
                        submitComplete={submitComplete}
                        checkCodeValidity={checkCodeValidity}
                    />
                )}
                <PersonalDataFormVerification
                    closeModal={this.closeVerificationCodeModal}
                    onSubmit={this.handleSubmitForVerificationCode}
                    showModal={this.state.showVerificationModal}
                    recallCodeCheck={this.props.recallCodeCheck}
                />
                {this.renderInfoModal()}
                {this.renderFormEndModal()}
            </div>
        );
    }
}

PersonalDataForm.propTypes = {
    personalDataActions: PropTypes.object,
    configMessage: PropTypes.string,
    certificateAndEmailValidated: PropTypes.bool,
    languageCode: PropTypes.string,
    openErrorModal: PropTypes.func,
    recallCodeCheck: PropTypes.func,
    clientDesignator: PropTypes.string,
    blockSubmit: PropTypes.bool,
    setBlockSubmit: PropTypes.func,
    existingEmail: PropTypes.string,
    confirmExistingEmail: PropTypes.string,
    memberIdentifier: PropTypes.string,
    checkCode: PropTypes.string,
    fieldsToShow: PropTypes.object,
    handleSubmit: PropTypes.func,
    resetEmailValidation: PropTypes.func,
    checkCodeValidity: PropTypes.number,
};

function mapStateToProps(state) {
    const selector = formValueSelector("personalDataForm");
    const verificationForm = formValueSelector("verificationCodeForm");
    let fieldsToShow = {};
    let memberInitialData = {};
    let codeValidity = 30;
    if (state.personalData.hasOwnProperty("memberFormData")) {
        const personalData = state.personalData.memberFormData.data;

        if (personalData) {
            if (personalData.hasOwnProperty("memberPersonalDataFields")) {
                const memberPersonalDataFields = personalData["memberPersonalDataFields"]; // array of objs.

                memberPersonalDataFields.forEach((obj) => {
                    /**
                     * We need to extract the field name from API response. Since the fields do not represent the keys (our typical API responses),
                     * reduxForms won't be able to interpret them unless we change the structure programatically.
                     */
                    let field = obj["field"];
                    field = toCamelCase(field);
                    fieldsToShow[field] = true;
                    /**
                     * This personalDataConfiguration object will be sent as the initialValues (reduxForms) prop in order to show the saved checkbox values from db in the fields component.
                     */
                });
            }

            if (personalData.hasOwnProperty("member")) {
                memberInitialData = personalData["member"];
            }

            if (personalData.hasOwnProperty("codeValidity")) {
                codeValidity = personalData["codeValidity"];
            }
        }
    }

    return {
        memberIdentifier: selector(state, "memberIdentifier"),
        existingEmail: selector(state, "existingEmail"),
        confirmExistingEmail: selector(state, "confirmExistingEmail"),
        fieldsToShow: fieldsToShow,
        memberInitialValues: memberInitialData,
        checkCode: verificationForm(state, "checkCode"),
        checkCodeValidity: codeValidity,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        personalDataActions: bindActionCreators(personalDataAction, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: "personalDataForm",
        validate: (values) => validationUtils.validate(values, personalDataValidationRules),
    })(PersonalDataForm)
);



// WEBPACK FOOTER //
// ./src/components/personal-data/PersonalDataForm.js